import { Betslip } from '../../models/BetSlip';
import { BsData } from '../../models/BsData';
import { EventData, MatchOdds } from '../../models/EventData';
import { UserBet } from '../../models/UserBet';
import {
  ADD_EXCH_BET,
  BET_ODDS_CHANGE,
  REMOVE_EXCH_BET,
  SET_EXCH_BET_STAKE,
  CLEAR_EXCHANGE_BETS,
  FETCH_OPEN_BETS_SUCCESS,
  CLEAR_SUCCESS_BETS,
  SET_BETTING_INPROGRESS,
  BETSLIP_ODDS_CHANGED_MSG,
  UPDATE_BET_DETAILS,
  UPDATE_BET_SLIP,
  ACCEPT_ODDS_CHANGE,
} from './betSlipActionTypes';

type Action = {
  type: string;
  payload: any;
};

const initialState: Betslip = {
  bets: [],
  openBets: [],
  bettingInprogress: false,
  oddsChanged: false,
  betSuspended: false,
  message: '',
};

const betslipReducer = (state = initialState, action: Action): Betslip => {
  switch (action.type) {
    case ADD_EXCH_BET: {
      const bettingInprogress = state.bettingInprogress;
      if (!bettingInprogress) {
        let bets = [...state.bets];
        bets = [action.payload];
        return {
          ...state,
          bets,
          oddsChanged: false,
          betSuspended: false,
          message: '',
        };
      }
      return {
        ...state,
      };
    }

    case UPDATE_BET_DETAILS: {
      return {
        ...state,
        bets: action.payload,
      };
    }

    case BET_ODDS_CHANGE: {
      const bets = [...state.bets];
      bets[action.payload.index].oddValue = action.payload.odds
        ? action.payload.odds
        : null;

      return {
        ...state,
        bets,
      };
    }

    case REMOVE_EXCH_BET: {
      // const bets = [...state.bets];
      // bets.splice(action.payload.index, 1);
      return {
        ...state,
        bets: [],
        oddsChanged: false,
        betSuspended: false,
        message: '',
      };
    }

    case SET_EXCH_BET_STAKE: {
      const bets = [...state.bets];
      if (action.payload.type === 'ADD') {
        bets[action.payload.index].stakeAmount += action.payload.amount;
      } else if (action.payload.type === 'SET') {
        bets[action.payload.index].stakeAmount = action.payload.amount;
      }

      if (isNaN(bets[action.payload.index].stakeAmount)) {
        bets[action.payload.index].stakeAmount = 0;
      }

      return {
        ...state,
        bets,
      };
    }

    case CLEAR_EXCHANGE_BETS: {
      const bettingInprogress = state.bettingInprogress;
      if (!bettingInprogress) {
        return {
          ...state,
          bets: [],
          oddsChanged: false,
          betSuspended: false,
          message: '',
        };
      }
      return {
        ...state,
      };
    }

    case FETCH_OPEN_BETS_SUCCESS: {
      return {
        ...state,
        openBets: action.payload,
      };
    }

    case SET_BETTING_INPROGRESS: {
      return {
        ...state,
        bettingInprogress: action.payload,
      };
    }

    case BETSLIP_ODDS_CHANGED_MSG: {
      return {
        ...state,
        oddsChanged: action.payload,
      };
    }

    case CLEAR_SUCCESS_BETS: {
      // const currentBets = [...state.bets];
      // const successIndices: number[] = action.payload;

      // const filteredBets = currentBets.filter(
      //   (_, i) => !successIndices.includes(i)
      // );

      return {
        ...state,
        bets: [],
      };
    }

    case UPDATE_BET_SLIP: {
      const eInfo: EventData = action.payload;
      const markets: MatchOdds[] = eInfo?.markets?.matchOdds
        ? eInfo.markets.matchOdds
        : [];
      let bet: BsData = [...state.bets][0];
      let oddsChnaged = state.oddsChanged;
      let betSuspended = state.betSuspended;
      let message = state.message;
      if (bet && bet.eventId === eInfo.eventId) {
        if (
          ['suspended', 'closed'].includes(eInfo.status.toLowerCase()) ||
          markets.length === 0
        ) {
          betSuspended = true;
          message = 'Event is not Active!';
        } else {
          // betSuspended = false;
          for (const mr of markets) {
            if (bet.marketId === mr.marketId) {
              if (
                !['active', 'open'].includes(mr.status.toLowerCase()) ||
                mr.runners.length === 0
              ) {
                betSuspended = true;
                message = 'Market is not Active!';
              } else {
                // betSuspended = false;
                for (const rn of mr.runners) {
                  if (bet.runnerId === rn.runnerId) {
                    if (!['active', 'open'].includes(rn.status.toLowerCase())) {
                      betSuspended = true;
                      message = 'Runner is not Active!';
                    } else {
                      // betSuspended = false;
                      if (
                        !betSuspended &&
                        bet.oddValue !== rn.backPrices[0].price
                      ) {
                        bet.oddValue = rn.backPrices[0].price;
                        oddsChnaged = true;
                        message = 'Odds Changed!';
                      }
                    }
                  }
                }
              }
              break;
            }
          }
        }
      }
      return {
        ...state,
        bets: bet?.marketId ? [bet] : [],
        oddsChanged: oddsChnaged,
        betSuspended: betSuspended,
        message: message,
      };
    }

    case ACCEPT_ODDS_CHANGE: {
      return {
        ...state,
        oddsChanged: false,
        message: '',
      };
    }
    default: {
      return state;
    }
  }
};

export default betslipReducer;
